module.exports = __webpack_public_path__ + "static/increase-urgency-e2fe5e40a419cc4892238bcaafca5efc.png";